module.exports = __webpack_public_path__ + "img/image44.ece9cf29.png";